import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';
import ListingChipsContainer from '@spotahome/ui-library/src/tenant/components/ListingChipsContainer';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import { formatFeaturesToChipList } from '@spotahome/ui-library/src/tenant/components/PropertyRulesRedesign/utils';

import { ListingSectionObservable } from '../ListingSection';

import openPropertyRulesSimplifiedModal from './PropertyRulesSimplifiedModal';

import './PropertyRulesSimplified.scss';

const MAX_VISIBLE_CHIPS = 8;

const PropertyRulesSimplified = ({ propertyRules, currency }) => {
  const propertyFeaturesChips = formatFeaturesToChipList(
    propertyRules,
    currency
  ).filter(Boolean);

  return (
    <>
      <ListingTitle
        role="secondary"
        className="property-rules-simplified__section-title"
      >
        {trans('listing.simplification.bottom.landlord-rules.section.title')}
      </ListingTitle>
      <ListingSectionObservable
        section="landlordRules"
        className="property-rules-simplified"
      >
        <ListingTitle role="secondary">
          {trans('listing.simplification.bottom.landlord-rules.card.title')}
        </ListingTitle>
        <ListingChipsContainer
          chipList={propertyFeaturesChips}
          maxVisibleChips={MAX_VISIBLE_CHIPS}
          showShowMoreButton={false}
        />
        <Button
          type="button"
          color="link"
          className="property-rules-simplified__view-more"
          onClick={() =>
            openPropertyRulesSimplifiedModal({
              propertyFeaturesChips,
              fullscreenOnMobile: true
            })
          }
        >
          {trans('common.view-more')}
        </Button>
      </ListingSectionObservable>
    </>
  );
};

PropertyRulesSimplified.propTypes = {
  propertyRules: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired
};

export default PropertyRulesSimplified;
